module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.toggleLiked
    }
  }, [(_vm.liked) ? _c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("favorite")]) : _c('v-icon', [_vm._v("favorite_border")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d9167da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonLikeAudio.vue
// module id = 392
// module chunks = 0